export const FeedOperation = {
  OPEN_FREE_FALL: 'OPEN FREE FALL',
  CLOSE_FREE_FALL: 'CLOSE FREE FALL',
  JOG_OPEN: 'JOG OPEN',
  JOG_CLOSE: 'JOG CLOSE',
  SETTLING: 'SETTLING',
};
